module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="form weld top-margined">\r\n    <div class="col-md-4 col-xs-4">\r\n        <table class="table table-condensed vertical-aligned-table" id="external-ids-table">\r\n            <thead>\r\n            <tr>\r\n                <th class="center">External Id</th>\r\n                <th class="center">Edit</th>\r\n                <th class="center">Remove</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            ';
 _.each(externalIds, function(externalId, indx) { 
__p+='\r\n            <tr>\r\n                <td class="center">\r\n                    <span class="text">'+
((__t=( externalId ))==null?'':__t)+
'</span>\r\n                    <input type="text" class="form-control external-id-text" value="'+
((__t=( externalId ))==null?'':__t)+
'" style="min-width: 100px; display: none;" placeholder="Type and Press Enter"/>\r\n                </td>\r\n                <td class="center"><span class="glyphicon glyphicon-edit clickable external-id-edit" rel-id="'+
((__t=( externalId ))==null?'':__t)+
'"/></td>\r\n                <td class="center"><span class="glyphicon glyphicon-remove clickable external-id-remove" rel-id="'+
((__t=( externalId ))==null?'':__t)+
'"/></td>\r\n            </tr>\r\n            ';
 }) 
__p+='\r\n            </tbody>\r\n        </table>\r\n        <div class="top-margined">\r\n            <button type="button" class="btn btn-success btn-sm" id="add-new-external-id">Add new</button>\r\n        </div>\r\n    </div>\r\n    <div class="col-md-2 col-xs-2">\r\n        <button type="button" class="btn btn-primary btn-sm" id="save-external-ids">Save</button>\r\n        <button type="button" class="btn btn-primary btn-sm" id="cancel-external-ids-save">Cancel</button>\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/common/external-ids-view.html
// module id = 275
// module chunks = 0